import { v4 as uuidv4 } from "uuid"
import { pushProcessLogEventLogger } from "../app/services/LogEvents/pushProcessLogEventLogger"

export const logEvent = async (
  processName,
  eventText,
  transactionId = null,
) => {
  try {
    const myuuid = transactionId || uuidv4()
    const event = {
      transactionId: myuuid,
      processName: String(processName),
      logType: "NOTIFY",
      eventText,
    }
    await pushProcessLogEventLogger(event)
  } catch (error) {
    console.log(error)
  }
}
